import { createFileRoute, Outlet } from '@tanstack/react-router';

/** Layout-only: gives the editor routes a "Products" crumb that links back to the list. */
export const Route = createFileRoute('/_authed/_active/org/products')({
  staticData: { crumb: 'common:nav.products' },
  component: Outlet,
});
